import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  rechercherentreprises,
  rechercherentreprisespartenaires,
  recherchersiteparentreprise,
  rechercherSites,
} from "../services/entreprises/entrepriseRequest";

import { DecodeToken } from "../DecodeToken";

function ListeEntreprise(props) {
  const [entrepriseSelected, setentrepriseSelected] = useState(null);
  const [siteEntrepriseSelected, setSiteEntrepriseSelected] = useState(null);
  const [listeEntreprise, setlisteEntreprise] = useState([]);
  const [listeSiteEntreprise, setListeSiteEntreprise] = useState([]);

  const handlePlatday = (values) => {
    setentrepriseSelected(values);
    props.setdataSelected(values);
  };

  const handleSitePlatday = (values) => {
    setSiteEntrepriseSelected(values);
    props.setdataSiteSelected(values);
  };

  const afficherEntreprise = () => {
    if (DecodeToken().profil == "ROLE_RESTAURATRICE") {
      rechercherentreprisespartenaires().then((response) => {
        setlisteEntreprise(response.data.donnee);
      });
    } else {
      rechercherentreprises().then((response) => {
        setlisteEntreprise(response.data.donnee);
      });
    }
  };

  const rechercherSitesEntrepriseConnecte = () => {
    rechercherSites()
      .then((response) => {
        setListeSiteEntreprise(response.data.donnee);
      })
      .catch(() => {
        console.log("++++ error sites");
      });
  };

  const afficherSiteEntreprise = (entreprise) => {
    if (entreprise) {
      recherchersiteparentreprise(entreprise.id).then((res) => {
        setListeSiteEntreprise(res.data.donnee);
      });
    } else {
      setListeSiteEntreprise([]);
    }
  };

  useEffect(() => {
    afficherEntreprise();
    if (DecodeToken().profil == "ROLE_COMPTABLE") {
      rechercherSitesEntrepriseConnecte();
    }
  }, []);

  return (
    <div className=" d-flex justify-content-end gap-1">
      {(DecodeToken().profil == "ROLE_ADMIN" || DecodeToken().profil == "ROLE_RESTAURATRICE") && (
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={
              DecodeToken().profil == "ROLE_ADMIN" ||
                DecodeToken().profil == "ROLE_RESTAURATRICE"
                ? listeEntreprise
                : props.listecomandeentreprise
            }
            getOptionLabel={(option) => option.raisonSociale ?? option}
            value={entrepriseSelected || props.entrepriseSelected}
            onChange={(event, value) => {
              afficherSiteEntreprise(value);
              handlePlatday(value);
            }}
            sx={{ width: props.width !== undefined ? props.width : 250 }}
            size="small"
            renderInput={(params) => (
              <TextField {...params} className="bg-white" label="Entreprises" />
            )}
          />
        )}
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={listeSiteEntreprise}
        getOptionLabel={(option) => option.nom ?? option}
        value={siteEntrepriseSelected || props.siteEntrepriseSelected}
        onChange={(event, value) => {
          handleSitePlatday(value);
        }}
        sx={{ width: props.width !== undefined ? props.width : 250 }}
        size="small"
        renderInput={(params) => (
          <TextField {...params} className="bg-white" label="Site entreprise" />
        )}
      />
    </div>
  );
}

export default ListeEntreprise;
